import AxiosConfig from "./AxiosConfig";
import {
    getColorsList,
    getElanciaColorsList,
    getRandomColor,
    getRandomInArray,
    increaseDark,
    increaseSaturation
} from "./UtilsService";


const getStatsMainPage = async (params) => {
    let url = params ? `/stats/main?${params}` : `/stats/main`;
    try {
        const response = await AxiosConfig.get(url);
        return response.data;
    } catch (error) {
        console.error('error: ', error);
        throw error;
    }
}

const getStatsSalariesParActiviteTypePage = async () => {
    try {
        const response = await AxiosConfig.get(`/stats/activites_participation_salaries`);
        return response.data;
    } catch (error) {
        console.error('error: ', error);
        throw error;
    }
}

const parseStatsSalariesParActiviteType = (data) => {
    let myColors = [];
    let colorsList = getElanciaColorsList();

    for (let i = 0; i < data.length; i++) {
        let rdmClr;
        let attempts = 0;

        do {
            rdmClr = getRandomInArray(colorsList);
            attempts++;
        } while (myColors.includes(rdmClr) && attempts < 100);

        data[i].fill = rdmClr;
        data[i].fillBorder = increaseDark(increaseSaturation(rdmClr, 30), 30);
        myColors.push(rdmClr);
    }

    return data;
}

const getStatsTabSeancesPage = async (queryParams = null) => {
    let url = queryParams ? `/stats/tab_seances${queryParams}` : `/stats/tab_seances`;

    try {
        const response = await AxiosConfig.get(url);
        return response.data;
    } catch (error) {
        console.error('error: ', error);
        throw error;
    }
}


const getStatsTabActiviteTypesPage = async (queryParams = null) => {
    let url = queryParams ? `/stats/tab_activite_types${queryParams}` : `/stats/tab_activite_types`;

    try {
        const response = await AxiosConfig.get(url);
        return response.data;
    } catch (error) {
        console.error('error: ', error);
        throw error;
    }
}

const getStatsTabUsersPage = async (queryParams = null) => {
    let url = queryParams ? `/stats/tab_users${queryParams}` : `/stats/tab_users`;

    try {
        const response = await AxiosConfig.get(url);
        return response.data;
    } catch (error) {
        console.error('error: ', error);
        throw error;
    }
}

export {
    getStatsMainPage,
    getStatsSalariesParActiviteTypePage,
    parseStatsSalariesParActiviteType,
    getStatsTabSeancesPage,
    getStatsTabUsersPage,
    getStatsTabActiviteTypesPage
};
